import type { GiftPassBundle } from '@bonsai/shared';
import { Link } from 'react-router-dom';

import { giftPassBundlePath } from '../gift-pass-bundles-paths';

import { GiftPassBundleCardContent } from './GiftPassBundleCardContent';

import '../../shared/list-page/list-page.css';
import './gift-pass-bundles-list.css';

export interface GiftPassBundleCardProps {
  bundle: GiftPassBundle;
  canOpen: boolean;
}

export function GiftPassBundleCard({ bundle, canOpen }: GiftPassBundleCardProps) {
  const className = `nb-listpage-card${bundle.isActive ? '' : ' gpb-inactive'}`;
  const content = <GiftPassBundleCardContent bundle={bundle} showChevron={canOpen} />;
  if (!canOpen) return <article className={className}>{content}</article>;
  return (
    <Link
      to={giftPassBundlePath(bundle.id)}
      aria-label={`Open bundle ${bundle.name}`}
      className={className}
    >
      {content}
    </Link>
  );
}
